import { styled } from 'styled-components';
import FirstTableItem from '../../components/Table/FirstTableItem';
import TableItem from '../../components/Table/TableItem';

import { ReactComponent as DetailsIcon } from '../../assets/icons/details.svg';

export const TableBodyRow = styled.tr`
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  display: flex;
  width: 100%;
  background-color: ${props => props.$active && '#48488815'};

  cursor: ${props => (props.$offClick ? 'default' : 'pointer')};

  min-height: 6.4rem;
  gap: 4rem;

  &:last-of-type {
    border-bottom: none;
  }
  &:hover {
    background-color: #48488815;
    transition: all 0.2s ease-in-out;
  }
  &:nth-child(even) {
    background-color: #48488810;
  }
`;

export const FirstItem = styled(FirstTableItem)`
  padding-left: 18px;
`;

export const LastTableItem = styled(TableItem)`
  padding-right: 16px;
  justify-content: flex-end;
  justify-content: center;
  /* background-color: red; */
  z-index: 10;
  cursor: pointer;
  &:active {
    opacity: ${props => (props.$offClick ? 1 : 0)};
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;

  color: #fff;
  font-family: 'Avenir-Medium';
  font-size: 1.6rem;
  letter-spacing: -0.178px;

  border-radius: 1.5rem;
  background-color: ${props => (props.$accepted ? '#4CA953' : '#484888')};
  height: 4rem;
  width: 14rem;
  box-shadow: 0px 5px 10px #48488850;
  transition: all 0.3s ease-in-out;
`;

export const Details = styled(DetailsIcon)`
  cursor: pointer;
`;
